// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { ComponentPropsWithRef } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import style from 'react-syntax-highlighter/dist/esm/styles/prism/darcula'
import gfm from 'remark-gfm'

import { S } from './styles';

function handleContextMenu(e: React.MouseEvent<HTMLElement>) {
  const allow = ['A', 'PRE', 'CODE']
  if (allow.includes((e.target as HTMLElement).tagName)) {
    e.stopPropagation();
  } else {
    e.preventDefault();
  }
}

const Image = (props: ComponentPropsWithRef<'img'>): JSX.Element => {
  return <S.Img
    alt=""
    {...props}
    draggable={false}
  />
}

export interface MarkdownProps extends ComponentPropsWithRef<'div'> {
  markdown: string;
  baseUrl?: string;
  mdImageUrl? :string;
  challengePassword?: string;
  id?: string;
}

interface CodeProps extends React.ComponentPropsWithRef<'code'> {
  value: string;
  language: string;
}

const Code = ({ value = '', language }: CodeProps): JSX.Element => {
  return <SyntaxHighlighter
    style={{ ...style, backgroundColor: '' }}
    customStyle={{ backgroundColor: '' }}
    language={language}
    showLineNumbers={true}
  >
    {value.trimEnd()}
  </SyntaxHighlighter>
}

const Markdown = ({ markdown, baseUrl, mdImageUrl, id, challengePassword, ...props }: MarkdownProps): JSX.Element => {
  const uriParser = (uri: string) => {
    if (uri.includes('./materials')) {
      return `${baseUrl}/${uri.slice(2)}`
    } else {
      return uri.indexOf('./') === 0 ? `${mdImageUrl}${uri.slice(2)}` : uri
    }

  }
  const markdownParsed = (markdown: string) => {
    return markdown.replace(/\$\{s3Url\}/g, `${baseUrl}`).replace(/\$\{password\}/g, `${challengePassword}`)
  }
  const Link = (props: ComponentPropsWithRef<'a'>): JSX.Element => {
    const url = props.href?.[0] === '.' ? baseUrl + props.href : props.href;
    return <a {...props} target="_blank" href={url} rel="noreferrer" onContextMenu={handleContextMenu} />
  }

  const ParsedHtml = ({ value }: any) => {
    const commentTagRegex = new RegExp(/<!--(?:.|\n|\r)*?-->/g)
    const imageTagRegex = new RegExp(/<img src="([^"]+)"/g)

    const sanitizedValue = value.replace(commentTagRegex, '');
    const result = imageTagRegex.exec(sanitizedValue) || [];

    if (result[1]) {
      return <S.Img
        alt="challenge-img"
        src={`${uriParser(result[1])}`}
        draggable={false}
        onContextMenu={(handleContextMenu)}
      />
    }

    return (
      <div dangerouslySetInnerHTML={{ __html: value }} />
    );
  }

  const renderers = {
    image: Image,
    link: Link,
    html: ParsedHtml,
    code: Code,
  }

  return (
    <S.Wrapper
      data-testid="challenge-experiment"
      className="view-all-content-wrapper-challenge"
      id={id}
      onContextMenu={handleContextMenu}
      {...props}
    >
      <S.ReactMarkdown
        source={markdownParsed(markdown)}
        transformImageUri={uriParser}
        transformLinkUri={uriParser}
        renderers={renderers}
        plugins={[gfm]}
      />
      {
        markdown ? '' : (
          <S.WrapperLeft
            className="wrapper-left"
            dangerouslySetInnerHTML={{ __html: markdownParsed(markdown) }}
          />
        )
      }
    </S.Wrapper>
  );
}

export default React.memo(Markdown);
